import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-3xl font-semibold">404</p>
        <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
          That page doesn&rsquo;t exist.
        </p>
      </div>
    </div>
  ),
})
